var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscord = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.942 9.523a16.288 16.288 0 0 0-4.126-1.296c-.178.32-.386.753-.529 1.097a15.15 15.15 0 0 0-4.573 0 11.727 11.727 0 0 0-.534-1.097c-1.45.25-2.835.692-4.13 1.3-2.611 3.945-3.319 7.793-2.965 11.587a16.495 16.495 0 0 0 5.06 2.593c.408-.56.771-1.157 1.084-1.785a10.647 10.647 0 0 1-1.706-.83c.143-.107.283-.218.418-.332 3.29 1.54 6.866 1.54 10.118 0 .137.114.277.225.418.331a10.63 10.63 0 0 1-1.71.832c.314.627.675 1.225 1.084 1.786a16.464 16.464 0 0 0 5.064-2.595c.415-4.398-.71-8.21-2.973-11.59Zm-10.264 9.258c-.988 0-1.798-.922-1.798-2.046 0-1.122.792-2.046 1.798-2.046 1.005 0 1.815.922 1.798 2.046.001 1.124-.793 2.046-1.798 2.046Zm6.644 0c-.988 0-1.798-.922-1.798-2.046 0-1.122.793-2.046 1.798-2.046 1.006 0 1.816.922 1.798 2.046 0 1.124-.793 2.046-1.798 2.046Z",
    fill: "#fff"
  })));
};
export default SvgDiscord;